<section>
    <div class="modal-header">
      <h4 class="modal-title">Confirmation</h4>
    </div>
  
    <div *ngIf="Message !== 'userDefault'" class="modal-body" style="height:120px">
      {{Message}}
    </div>
  </section>
